import Vue from 'vue'
import VueI18n from 'vue-i18n'

import axios from 'axios'

Vue.use(VueI18n)
export default class LocaleProvider {
  localesUrl: string
  i18n: VueI18n
  messagePacks: string[]

  constructor (baseLocalesUrl: string, messagePacks: string[]) {
    this.localesUrl = baseLocalesUrl
    this.i18n = new VueI18n({})
    this.messagePacks = messagePacks
  }

  async asyncLoadLanguage (locale: string) {
    // If the same language
    if (this.i18n.locale === locale) {
      return Promise.resolve()
    }

    const messages: any = {}
    for (let index = 0; index < this.messagePacks.length; index++) {
      const packName = this.messagePacks[index]
      const url = `${this.localesUrl}/${packName}/${locale}.json`
      try {
        const { data } = await axios.get(url)
        messages[packName] = data
      } catch {
        messages[packName] = {}
      }
    }

    this.i18n.setLocaleMessage(locale, messages)
    this.i18n.locale = locale
  }
}
